import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthProvider";
import { AppContext } from "../../context/AppProvider";
import { fetchWithInterceptor } from "../../utils/fetchWithInterceptor";

export default function ConfirmStartDialog({ open, onClose }) {
  const authContext = useContext(AuthContext)
  const appContext = useContext(AppContext);

  const onConfirm = async () => {
    try {
      const response = await fetchWithInterceptor("/api/receiving/sync", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": authContext.getToken(),
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        appContext.showMessage(errorData.error || "Error starting process", "error");
      }
      onClose()
    } catch (error) {
      console.log(error);
      appContext.showMessage("There was an error syncing products. Try again later.", "error");
    }
  }

  return (
    <Dialog
      onClose={onClose}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      aria-labelledby="delete-dialog"
      open={open}
    >
      <DialogTitle id="delete-dialog">Start process</DialogTitle>
      <DialogContent>
        <Typography>
          Products will be retrieved from Cin7 to begin the receiving session. This may take a few minutes.
        </Typography>
        <Typography>
          If another sync or operation is currently in progress, it may be interrupted. Do you want to continue?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          Start
        </Button>
      </DialogActions>
    </Dialog>
  )
}